/** @override King Living: SplitPanelDoubleImageBlockFragment (extended base with colour fields). */

import gql from 'graphql-tag';

import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {ShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/shop-the-look.fragment';
import {BaseSplitPanelDoubleImageBlockFragment} from './base-split-panel-double-image-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const SplitPanelDoubleImageBlockFragment = gql`
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSplitPanelDoubleImageBlockFragment}
  ${ShopTheLookFragment}
  ${BaseVideoFragment}

  fragment SplitPanelDoubleImageBlockFragment on SplitPanelDoubleImageBlock {
    ...BaseSplitPanelDoubleImageBlockFragment

    contentCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
        ... on ShopTheLook {
          ...ShopTheLookFragment
        }
      }
    }
    primaryImage {
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
      ... on ShopTheLook {
        ...ShopTheLookFragment
      }
    }
  }
`;
